module.exports = __webpack_public_path__ + "img/Ausflug_2018.bcdcde9f.jpg";